import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const Header = styled.div`
  position: relative;
  display: flex;
  flex-shrink: 0;
  padding: 24px 8px 24px 16px;
  border-bottom: 1px solid ${COLORS.line};
`;

export default Header;
